import { NotificationActions as NotificationActionTypes } from '../../../data/constants/NotificationActions';

export const NOTIFICATION_ICON_LOOKUP = {
  [NotificationActionTypes.ACTION_TAG]: 'hand-o-right',
  [NotificationActionTypes.ACTION_LIKE]: 'thumbs-up',
  [NotificationActionTypes.ACTION_LIKE_POST]: 'thumbs-up',
  [NotificationActionTypes.ACTION_NEW_POST]: 'paper-plane',
  [NotificationActionTypes.ACTION_NEW_SINGLE_POST]: 'paper-plane',
  [NotificationActionTypes.ACTION_REPLY]: 'comments',
  [NotificationActionTypes.ACTION_NEW_COMMENT]: 'comment',
  [NotificationActionTypes.ACTION_ADDED_CONTENT]: 'file-o',
  [NotificationActionTypes.ACTION_EDITED_CONTENT]: 'file-o',
  [NotificationActionTypes.ACTION_BADGE_ISSUED]: 'gift',
  [NotificationActionTypes.ACTION_CERTIFICATE_ISSUED]: 'certificate',
  [NotificationActionTypes.ACTION_CERTIFICATE_REFRESHED]: 'certificate',
};

export const PAGINATION_THRESHOLD = 5000;
